/* tslint:disable */

/* eslint-disable */

/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import type { AxiosInstance, AxiosPromise, RawAxiosRequestConfig } from "axios";
import globalAxios from "axios";

// @ts-ignore
import {
  BASE_PATH,
  BaseAPI,
  COLLECTION_FORMATS,
  RequestArgs,
  RequiredError,
  operationServerMap,
} from "../base";
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  createRequestFunction,
  serializeDataIfNeeded,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  toPathString,
} from "../common";
import type { Configuration } from "../configuration";

/**
 * SysClusteringPatternExternalDataControllerApi - axios parameter creator
 * @export
 */
export const SysClusteringPatternExternalDataControllerApiAxiosParamCreator = function (
  configuration?: Configuration
) {
  return {
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllClusteringPatternPlayerTypesByDomain: async (
      domain: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'domain' is not null or undefined
      assertParamExists("getAllClusteringPatternPlayerTypesByDomain", "domain", domain);
      const localVarPath = `/api/v2/sys-data/{domain}/clustering-pattern/player-type/`.replace(
        `{${"domain"}}`,
        encodeURIComponent(String(domain))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions =
        baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * SysClusteringPatternExternalDataControllerApi - functional programming interface
 * @export
 */
export const SysClusteringPatternExternalDataControllerApiFp = function (
  configuration?: Configuration
) {
  const localVarAxiosParamCreator =
    SysClusteringPatternExternalDataControllerApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAllClusteringPatternPlayerTypesByDomain(
      domain: string,
      options?: RawAxiosRequestConfig
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string
      ) => AxiosPromise<{ [key: string]: { [key: string]: Array<string> } }>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.getAllClusteringPatternPlayerTypesByDomain(
          domain,
          options
        );
      const index = configuration?.serverIndex ?? 0;
      const operationBasePath =
        operationServerMap[
          "SysClusteringPatternExternalDataControllerApi.getAllClusteringPatternPlayerTypesByDomain"
        ]?.[index]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, operationBasePath || basePath);
    },
  };
};

/**
 * SysClusteringPatternExternalDataControllerApi - factory interface
 * @export
 */
export const SysClusteringPatternExternalDataControllerApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = SysClusteringPatternExternalDataControllerApiFp(configuration);
  return {
    /**
     *
     * @param {string} domain
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllClusteringPatternPlayerTypesByDomain(
      domain: string,
      options?: any
    ): AxiosPromise<{ [key: string]: { [key: string]: Array<string> } }> {
      return localVarFp
        .getAllClusteringPatternPlayerTypesByDomain(domain, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * SysClusteringPatternExternalDataControllerApi - object-oriented interface
 * @export
 * @class SysClusteringPatternExternalDataControllerApi
 * @extends {BaseAPI}
 */
export class SysClusteringPatternExternalDataControllerApi extends BaseAPI {
  /**
   *
   * @param {string} domain
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof SysClusteringPatternExternalDataControllerApi
   */
  public getAllClusteringPatternPlayerTypesByDomain(
    domain: string,
    options?: RawAxiosRequestConfig
  ) {
    return SysClusteringPatternExternalDataControllerApiFp(this.configuration)
      .getAllClusteringPatternPlayerTypesByDomain(domain, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
